import { createTheme } from '@mui/material/styles'
import { grey } from '@mui/material/colors'

const mainColor = '#28f'
const fontSizeh1 = 'calc(40px + (46 - 30) * ((100vw - 200px) / 1620))'
const fontSizeh2 = 'calc(30px + (46 - 30) * ((100vw - 200px) / 1620))'
const fontSizeh4 = 'calc(18px + (24 - 18) * ((100vw - 200px) / 1620))'
const fontSizeh6 = 'calc(1rem + 3*(100vw - 20rem)/980)'
const fontSizebody1 = 'calc(.85rem + 2*(100vw - 20rem)/980)'
const fontSizebody2 = 'calc(.75rem + 2*(100vw - 20rem)/980)'

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#181818'
    },
    primary: {
      main: mainColor
    },
    secondary: {
      main: grey[900]
    },
    info: {
      main: grey[100]
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(',')
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          color: grey[900],
          fontSize: fontSizeh1,
          fontWeight: 500
        },
        h2: {
          color: grey[900],
          fontSize: fontSizeh2,
          fontWeight: 500
        },
        h4: {
          color: grey[900],
          fontSize: fontSizeh4,
          fontWeight: 500
        },
        h6: {
          color: grey[900],
          fontSize: fontSizeh6,
          fontWeight: 500
        },
        body1: {
          color: grey[800],
          fontSize: fontSizebody1
        },
        body2: {
          color: grey[700],
          fontSize: fontSizebody2
        },
        subtitle1: {
          color: grey[800],
          fontSize: fontSizebody1,
          fontWeight: 500
        },
        gutterBottom: {
          marginBottom: '.75em'
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 500,
          textTransform: 'inherit'
        },
        sizeSmall: {
          padding: '2px 12px'
        },
        sizeMedium: {
          padding: '4px 16px'
        },
        sizeLarge: {
          padding: '12px 32px'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 12
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: {
          width: 48,
          height: 48
        }
      }
    }
  }
})
